import React from 'react';
import { trackAddToCart } from '../utils/metaPixel';
import { PaymentIconsRow } from './PaymentIcons';
export function CtaBlock({
  className = '',
  buttonText = 'Get Instant Access — $13.99'
}: {
  className?: string;
  buttonText?: string;
}) {
  return <div className={`flex flex-col items-center w-full ${className}`} data-id="element-13">
      <a href="https://templeofpages.com/cart/48643597205747:1" onClick={() => trackAddToCart()} className="inline-block w-full md:w-auto bg-editorial-accent hover:bg-red-700 text-editorial-accentText px-9 py-[18px] rounded-lg font-bold text-base md:text-lg transition-colors text-center no-underline font-sans" aria-label={buttonText} data-id="element-14">
        {buttonText}
      </a>

      <div className="mt-6 flex flex-col items-center gap-5 w-full" data-id="element-15">
        <p className="text-editorial-textMuted text-sm text-center flex flex-wrap justify-center gap-x-3 gap-y-2 leading-relaxed" data-id="element-16">
          <span className="whitespace-nowrap" data-id="element-17">📄 Instant PDF Download</span>
          <span className="hidden md:inline opacity-50" data-id="element-18">|</span>
          <span className="whitespace-nowrap" data-id="element-19">🔒 256-bit Secure Checkout</span>
          <span className="hidden md:inline opacity-50" data-id="element-20">|</span>
          <span className="whitespace-nowrap" data-id="element-21">
            ✅ 14-Day Money-Back Guarantee
          </span>
        </p>
        <PaymentIconsRow data-id="element-22" />
      </div>
    </div>;
}